import { OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { RestProvider } from 'src/app/providers/rest/rest';
import { NavController } from '@ionic/angular';
var ProfileHeaderComponent = /** @class */ (function () {
    function ProfileHeaderComponent(rest, router, navCtrl) {
        var _this = this;
        this.rest = rest;
        this.router = router;
        this.navCtrl = navCtrl;
        this.brand = { name: '', logoUrl: '' };
        this.routeBase = '/';
        this.canGoBack = false;
        router.events.subscribe(function (val) {
            if (val instanceof NavigationEnd) {
                _this.canGoBack = val.urlAfterRedirects != _this.routeBase;
            }
        });
    }
    ProfileHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Subscribe to the global isLoading Obserable as a subscription
        this.$isLoading = this.rest.getIsLoading()
            .subscribe(function (loading) {
            _this.isLoading = loading;
        });
    };
    ProfileHeaderComponent.prototype.ngOnDestroy = function () {
        // Destroy/Unsubscribe the global isLoading Obserable as a subscription
        if (this.$isLoading) {
            this.$isLoading.unsubscribe();
        }
    };
    ProfileHeaderComponent.prototype.goBack = function () {
        if (this.canGoBack) {
            this.navCtrl.back();
        }
    };
    Object.defineProperty(ProfileHeaderComponent.prototype, "showProfileHeader", {
        get: function () {
            var url = this.router.url;
            return url.indexOf('/dashboard/defect/add') === -1 && url.indexOf('/dashboard/defect/update') === -1;
        },
        enumerable: true,
        configurable: true
    });
    return ProfileHeaderComponent;
}());
export { ProfileHeaderComponent };
